import styled, { keyframes } from "styled-components";

export const fadeAndSlideIn = keyframes`
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fadeAndSlideDown = keyframes`
  100% {
    transform: translateY(10px);
    opacity: 1;
  }
  0% {
    transform: translateY(0);
    opacity: 0;
  }
`;

export const generateAnimationDelayCSS = (
  startIndex,
  delayIncrease,
  elements
) => {
  let css = "";
  let delay;
  for (let i = 1; i <= elements; i++) {
    delay = i % 3 === 0 ? i * delayIncrease : delay;
    css += `
      &:nth-of-type(${startIndex}n + ${i}) {
        animation-delay: ${delay}s;
      }
    `;
  }

  return css;
};

export const StyledHoverableImage = styled.div`
  animation: 0.2s ease-out 0s 1 normal backwards running ${fadeAndSlideIn};
  ${generateAnimationDelayCSS(3, 0.02, 100)}

  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding-bottom: 140%;
  border-radius: 8px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    cursor: pointer;
  }

  .image-card {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    cursor: pointer;
  }

  .image-card-overlay {
    position: absolute;
    inset: auto 0 0;
    z-index: 1;
    padding: 68px 10px 14px;
    border-radius: 0 0 8px 8px;
    background: linear-gradient(180deg, rgba(5, 7, 12, 0), rgba(5, 7, 12, 0.9) 58%, rgba(5, 7, 12, 0.98));
    text-align: center;
    pointer-events: none;
  }

  .image-card-title {
    color: #ffffff;
    font-family: Impact, "Arial Black", sans-serif;
    font-size: clamp(26px, 5vw, 44px);
    font-weight: 900;
    letter-spacing: 0.5px;
    line-height: 0.92;
    text-shadow: 0 4px 0 #05070c, 0 0 12px rgba(0, 0, 0, 0.8);
    text-transform: uppercase;
  }

  .image-card-provider {
    color: rgba(255, 255, 255, 0.82);
    font-size: 13px;
    font-weight: 800;
    line-height: 1.1;
    margin-top: 10px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.85);
  }
`;

export const StyledHoverableImgMainHome = styled.div`
  animation: 0.2s ease-out 0s 1 normal backwards running ${fadeAndSlideIn};
  ${generateAnimationDelayCSS(3, 0.02, 100)}

  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 20px;
  border-radius: 8px;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    cursor: pointer;
  }

  .image-card {
    border-radius: 8px;
    max-width: none;
    object-fit: cover;
    cursor: pointer;
  }
`;
